import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DocumentsComponent } from './components/documents/documents.component';
import { PoliticaSGIComponent } from './politica-sgi/politica-sgi.component';
import { ObjetivosSgiComponent } from './objetivos-sgi/objetivos-sgi.component';
import { ContextoOrganizacionComponent } from './contexto-organizacion/contexto-organizacion.component';
import { AnalisisDeRiesgosYOportunidadesComponent } from './analisis-de-riesgos-y-oportunidades/analisis-de-riesgos-y-oportunidades.component';
import { MatrizDeRequisitosLegalesComponent } from './matriz-de-requisitos-legales/matriz-de-requisitos-legales.component';
import { ModeloDePrevencionDeDelitosComponent } from './modelo-de-prevencion-de-delitos/modelo-de-prevencion-de-delitos.component';
import { MatrizSsomaComponent } from './matriz-ssoma/matriz-ssoma.component';
import { AuthGuard } from 'src/app/guard/auth.guard';


const routes: Routes = [
  {
    path: '',

    children: [
      { path: 'gasa/documentos/politicasgi', component: PoliticaSGIComponent ,  canActivate: [AuthGuard]},
      { path: 'gasa/documentos/objetivosgi', component: ObjetivosSgiComponent ,  canActivate: [AuthGuard]},
      { path: 'gasa/documentos/contexto-organizacional', component: ContextoOrganizacionComponent,  canActivate: [AuthGuard] },
      { path: 'gasa/documentos/analisis-de-riesgos-y-oportunidades', component: AnalisisDeRiesgosYOportunidadesComponent,  canActivate: [AuthGuard] },
      { path: 'gasa/documentos/matriz-de-requisitos-legales', component: MatrizDeRequisitosLegalesComponent,  canActivate: [AuthGuard] },
      { path: 'gasa/documentos/modelo-de-prevencion-de-delitos', component: ModeloDePrevencionDeDelitosComponent ,  canActivate: [AuthGuard]},
      { path: 'gasa/documentos/matriz-ssoma', component: MatrizSsomaComponent ,  canActivate: [AuthGuard]},
      { path: 'gasa/documentos/biblioteca', component: DocumentsComponent,  canActivate: [AuthGuard]},
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [
            RouterModule
           ]
})
export class DocumentosRoutingModule { }